.picker { display: flex; width: 620px; }

.presets {
  display: flex; flex-direction: column; gap: 2px;
  width: 168px; padding: 12px 8px;
  border-right: 1px solid var(--border-cell);
}
.preset {
  padding: 7px 10px; border-radius: 6px; text-align: left;
  font-size: 12px; line-height: 16px; color: var(--text-value); white-space: nowrap;
}
.preset:hover { background: var(--bg-table-header); }
.preset.active { background: var(--bg-row-selected); font-weight: 600; }

.body { flex: 1 0 0; padding: 12px; }
.months { display: flex; gap: 20px; }
.month { width: 224px; }

.monthHead {
  display: flex; align-items: center; justify-content: space-between;
  height: 28px; margin-bottom: 6px;
  font-size: 12px; font-weight: 600; color: var(--text-title);
}
.nav {
  width: 24px; height: 24px; border-radius: 6px; color: var(--text-muted);
  display: inline-flex; align-items: center; justify-content: center; font-size: 14px;
}
.nav:hover { background: var(--bg-table-header); color: var(--text-value); }
.nav:disabled { opacity: 0.3; cursor: not-allowed; }

.grid { display: grid; grid-template-columns: repeat(7, 1fr); gap: 2px; }
.dow {
  height: 24px; display: flex; align-items: center; justify-content: center;
  font-size: 10px; font-weight: 600; color: var(--text-muted);
}
.day {
  height: 28px; border-radius: 6px;
  display: flex; align-items: center; justify-content: center;
  font-size: 12px; color: var(--text-value);
}
.day:hover:not(:disabled) { background: var(--bg-table-header); }
.day:disabled { color: #c9ccd1; cursor: not-allowed; }
.inRange { background: var(--bg-row-selected); border-radius: 0; }
.edge { background: #2f6feb; color: #fff; font-weight: 600; }
.edge:hover { background: #2f6feb; }
.blank { height: 28px; }

.footer {
  display: flex; align-items: center; justify-content: space-between; gap: 12px;
  margin-top: 12px; padding-top: 12px; border-top: 1px solid var(--border-cell);
}
.summary { font-size: 11px; line-height: 16px; color: var(--text-muted); }
.summary strong { color: var(--text-value); font-weight: 600; }
.actions { display: flex; gap: 8px; }
.btn {
  padding: 7px 14px; border-radius: 6px; font-size: 12px; font-weight: 500;
  border: 1px solid var(--border-control); color: var(--text-value); background: #fff;
}
.btn:hover { background: var(--bg-table-header); }
.primary { background: #2f6feb; border-color: #2f6feb; color: #fff; }
.primary:hover { background: #2559c4; }
.primary:disabled { opacity: 0.5; cursor: not-allowed; }
